import gql from 'graphql-tag';

export const GET_GOOGLE_MAPS_PUBlIC_API_KEY = gql`
 query googleMapsPublicApiKey {
    googleMapsPublicApiKey
 }
`;
